import { LocationDto } from "../../../../../Api/Model/LocationDto.csharp";

export const locationInitialState: LocationDto = {
  id: "",
  centers: [],
  contactFormUrl: "",
  locationId: "",
  name: "",
  noOnlineBookingInfo: "",
  supportsOnlineBooking: true,
  isLocation: false,
  concatCenterLocationInLocationDropdown: false,
  excludeFromListings: false,
  servicesWithDisabledDoctorSelection: [],
  specializations: [],
  ignoreMissingAppointmentsStatistics: false,
};
